module.exports = __webpack_public_path__ + "static/media/flower9.bc5e54aa.png";